export default class Constants {
  static STRIPE_DEV_PUBLISHABLE_KEY =
    'pk_test_51OUyrqKgtG7rdkIsOyHGljY8wlpAFH5PlzpYOm1DODif3tmecgKdcIKiWrGlvVfD5kbzriyyj9ptOi0Y6Al3ISum000fmXPDnU';
  static STRIPE_PROD_PUBLISHABLE_KEY =
    'pk_live_51OUyrqKgtG7rdkIs3R560TmMP0wZa5Z45AWEvA3t2wpb8uJ5AbxtV7wMHOL67bcmEJYz05uaK1yzjMhKMX7L1k9Q00uigoVQax';

  static SEATIO_STAGING_WORKSPACE_KEY = '51e07e77-84c6-4b05-83dd-85207e817343';
  static SEATIO_PROD_WORKSPACE_KEY = '7f411496-0be8-404e-8228-9532d6f4eb8c';
}
